import './BPMTableWidget.scss';
import cn from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import { WidgetContainer } from '../WidgetContainer';
import { Background, BackgroundType } from '../designConstants';

interface BPMTableWidgetProps extends PropsWithChildren {
  className?: string;
  dataTestId?: string;
  tableClassName?: string;
  background?: BackgroundType;
  fillHeight?: boolean;
  header?: ReactNode;
  rightActions?: ReactNode;
  footer?: ReactNode;
}

// The WidgetContainer+BPMTable half of the canonical "one big table" shape: fillHeight so the
// table stretches to the widget's own height instead of sizing to content, plus the child div
// BPMTable needs to actually receive that height. Most pages want this wrapped in TablePage's
// outer page chrome too -- reach for this directly only when composing a custom layout around
// it (e.g. two side-by-side tables).
export const BPMTableWidget = ({
  className,
  dataTestId,
  tableClassName,
  background = Background.DARK,
  fillHeight = true,
  header,
  rightActions,
  footer,
  children
}: BPMTableWidgetProps) => (
  <WidgetContainer
    className={cn('bpm-table-widget', className)}
    dataTestId={dataTestId}
    background={background}
    fillHeight={fillHeight}
    header={header}
    rightActions={rightActions}
    footer={footer}
  >
    <div className={cn('bpm-table-widget-table', tableClassName)}>{children}</div>
  </WidgetContainer>
);
